import { render } from "./CourseCard3.vue?vue&type=template&id=df7408b8&scoped=true"
import script from "./CourseCard3.vue?vue&type=script&lang=js"
export * from "./CourseCard3.vue?vue&type=script&lang=js"

import "./CourseCard3.vue?vue&type=style&index=0&id=df7408b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df7408b8"]])

export default __exports__